var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCsv24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19a2.5 2.5 0 002.5 2.5h9A2.5 2.5 0 0020 19V7.499a.5.5 0 00-.14-.347l-4.335-4.499a.5.5 0 00-.36-.153H8.5A2.5 2.5 0 006 5v3.811a.5.5 0 101 0V5a1.5 1.5 0 011.5-1.5h6V6a2 2 0 002 2H19v11a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 017 19v-.5a.5.5 0 00-1 0v.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.326 13.544c0 1.504.976 2.536 2.288 2.536 1.16 0 1.872-.68 2.056-1.672H5.654c-.168.456-.472.76-1.04.76-.784 0-1.248-.696-1.248-1.624 0-.936.464-1.624 1.248-1.624.568 0 .872.304 1.04.752H6.67c-.184-.984-.896-1.664-2.056-1.664-1.312 0-2.288 1.032-2.288 2.536zM7.558 14.6c.168.936.944 1.48 2.04 1.48 1.04 0 1.824-.576 1.824-1.528 0-.744-.488-1.2-1.288-1.384l-.896-.208c-.368-.088-.552-.256-.552-.536 0-.352.312-.576.776-.576.512 0 .792.256.904.584h1.016c-.16-.832-.808-1.424-1.928-1.424-1.032 0-1.768.624-1.768 1.512 0 .808.544 1.184 1.248 1.344l.88.2c.424.096.6.256.6.552 0 .392-.328.616-.824.616-.48 0-.84-.2-.976-.632H7.558zm9.234-3.512L14.944 16h-.992l-1.84-4.912h1.08l1.272 3.552 1.272-3.552h1.056z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsv24);
export default __webpack_public_path__ + "static/media/icon-csv-24.a67f3ae5.svg";
export { ForwardRef as ReactComponent };